/* eslint camelcase: 0 */
import { Media } from '@/infrastructure/network/Monitaro/schema/models'
import { IMediaProps, EmptyMediaPropsFactory } from '@/entities/Media'

export const toMediaProps = (props: Media | null | undefined): IMediaProps => {
  if (!props) {
    return EmptyMediaPropsFactory()
  }

  const { id, name, is_directory, properties, created_at, updated_at } = props

  return EmptyMediaPropsFactory({
    id,
    uploadId: 0,
    name,
    isDirectory: !!is_directory,
    properties,
    progress: 0,
    total: 0,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
